import React from 'react';
import { Building2, Users2, Wrench, FileText } from 'lucide-react';
import { propertyManagementFeatures, propertyManagementStats } from '../data/mock';
import { Button } from './ui/button';

const iconMap = {
  Building2: Building2,
  Users2: Users2,
  Wrench: Wrench,
  FileText: FileText
};

const PropertyManagement = () => {
  return (
    <section id="property-management" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="mb-16 text-center">
          <h2 className="text-sm font-semibold text-blue-600 mb-4 uppercase tracking-wide">Property Management</h2>
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Professional Property Management Solutions
          </h3>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Let us handle the day-to-day operations while you enjoy the returns. Our property management
            team ensures your assets are well-maintained, tenants are satisfied, and your investment
            performs at its best.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {propertyManagementFeatures.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            return (
              <div
                key={index}
                className="border-t-4 border-blue-600 bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                <div className="bg-blue-50 w-16 h-16 rounded-full flex items-center justify-center mb-4">
                  <Icon className="w-8 h-8 text-blue-600" />
                </div>
                <h4 className="text-xl font-semibold text-gray-900 mb-3">{feature.title}</h4>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            );
          })}
        </div>

        {/* Pre-Qualification CTA Button */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <Button
            onClick={() => window.location.href = '/pre-qualification'}
            size="lg"
            variant="outline"
            className="border-2 border-gray-400 text-gray-700 hover:bg-gray-100 hover:border-gray-500 text-lg px-12 py-6 h-auto shadow transition-all"
          >
            Resident Pre-Qualification
          </Button>
          <Button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            size="lg"
            className="bg-blue-600 hover:bg-blue-700 text-white text-lg px-12 py-6 h-auto shadow-lg hover:shadow-xl transition-all"
          >
            Optimize My Portfolio
          </Button>
        </div>
        <p className="text-gray-600 text-sm text-center mb-12">Free pre-qualification for prospective residents | Inquire about property management services</p>

        {/* Image Banner with Stats */}
        <div className="relative rounded-2xl overflow-hidden shadow-2xl">
          <img
            src="https://images.unsplash.com/photo-1681421760227-e996c82b881f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwc2t5bGluZXxlbnwwfHx8fDE3NjgwODk4ODR8MA&ixlib=rb-4.1.0&q=85"
            alt="Property Management"
            className="w-full h-[400px] object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-blue-700/70"></div>
          
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white">
            <h3 className="text-4xl font-bold mb-12">Managing Excellence Since 2013</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-16">
              {propertyManagementStats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-5xl font-bold mb-2">{stat.value}</div>
                  <div className="text-white/90 text-lg">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PropertyManagement;